import React from 'react';
import { Route, Switch } from 'react-router-dom';

import FiscalYears from './pages/FiscalYears';
import FiscalYearExperiments from './pages/FiscalYearExperiments';
import ExperimentRoot from './pages/ExperimentRoot';
import FolderContents from './pages/FolderContents';
import FileInformation from './pages/FileInformation'

import urls, { fiscalYearsUrl, fiscalYearExperimentsUrlTemplate, experimentRootUrlTemplate, folderContentsUrlTemplate, fileInformationUrlTemplate } from './urls';

const ViewerRoutes = () => {
  return (
    <Switch>
      <Route exact path={fiscalYearsUrl()} component={FiscalYears} />
      <Route exact path={fiscalYearExperimentsUrlTemplate()} component={FiscalYearExperiments}/>
      <Route exact path={experimentRootUrlTemplate()} component={ExperimentRoot} />
      <Route exact path={folderContentsUrlTemplate()} component={FolderContents} />
      <Route exact path={fileInformationUrlTemplate()} component={FileInformation} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default ViewerRoutes;
